module.exports = __webpack_public_path__ + "static/keyword_1-403a5a44aec0fde69c97e727c75a619c.jpg";